<template>
     
        <v-popover 
        :offset="40"
        :trigger="'manual'"
        :ref="keyId"
        :class="popoverClasses"
        :disabled="!isActive"
        :autoHide="false"
        :open="true">
     
            <span 
                @click="isActive ? popupHide(keyId,'fromclick' ): popupShow(keyId,'fromclick')"
                @keyup.enter="isActive ? popupHide(keyId,'fromenter'): popupShow(keyId,'fromenter')"
                @keyup.esc="popupHide(keyId, 'fromesc')"
                :tabindex="infoTabIndex"
                :class="infoIconClasses"
                 aria-label="læs mere"
                 focusLockIgnore>
                 {{infoIconReplaceText}}
            </span>

            <template slot="popover">
                    <FocusLock @clickOutsideLock="popupHide(keyId, 'fromfocus')" :returnfocus="true" :disabled="!isActive">
                        
                        <a 
                            @click.stop="popupHide(keyId,'fromclicklast')" 
                            @keyup.enter="popupHide(keyId,'fromenterlast')"
                            @keyup.esc="popupHide(keyId, 'fromesclast')"
                            :tabindex="!isActive ? '-1' :'0'" 
                            class="tooltip__close" 
                            aria-label="Luk modal boks">
                        </a>
                        <div v-html="text"></div>

                    </FocusLock>
           
            </template>

        </v-popover>

</template>

<script>

export default {
    name: "dropdown",
    props: ["id", "text", "popoverClasses", "infoIconTabIndex","infoIconReplaceText"],
    watch: { 
      	infoIconTabIndex: function(newVal, oldVal) { // watch it
          this.infoTabIndex = newVal && newVal !== undefined ? newVal : "0";
        }
    },
    data() {
        return {
            isActive: false,
            infoTabIndex: this.infoIconTabIndex && this.infoIconTabIndex !== undefined ? this.infoIconTabIndex : "0",
            infoIconClasses: this.infoIconReplaceText && this.infoIconReplaceText !== undefined ? "text--blue" : "icon-info icon--info tooltip-target",
        };
    },
    mounted(){
        this.$refs[this._uid].show();
    },
    computed: {
        keyId() {
            var result = this._uid;
            return result;
        }
    },
    methods: {
        popupHide(index, text)
        {
            this.isActive = false;
            this.$emit("popupIsClosed");
        },
        popupShow(index,text)
        {
            this.isActive = true;
            this.$emit("popupIsOpen");
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/PopupInfoBox.vue